<template>
  <div class="text-base">
    <GlobalHeader />
    <CommunityNavigationDesktop />
    <CommunityNavigationMobile />
    <main>
      <slot />
    </main>
    <GlobalFooter />

    <DebugGrid />
  </div>
</template>

<script setup lang="ts">
import { setThemeGlobalCssVariables } from '@/utils/theme-globals'
const { communityContent } = storeToRefs(useCurrentStoryStore())

// preload the config for use in header & footer
await useConfigStore().fetchConfig()

onMounted(() => {
  setThemeGlobalCssVariables(
    communityContent.value?.backgroundDark,
    communityContent.value?.backgroundLight,
    communityContent.value?.contentDark,
    communityContent.value?.contentLight,
  )
})

onUnmounted(() => {
  setThemeGlobalCssVariables()
})
</script>
